/**
 * File: VerificationCodePage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.1.1
 * Created: 2025-07-23
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// Local project files
import { TextButton } from "../components/ui/Buttons";
import { routes } from "../constants/routes";
import { sendOtpCode, verifyOtpCode } from "../utils/ServiceRequests";
import AuthPrompt from "../components/forms/AuthPrompt";
import DigitField from "../components/forms/DigitField";
import FormHeader from "../components/forms/FormHeader";
import Logo from "../components/ui/Logo";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function VerificationCodePage({ schema, otpEmail }) {
    const [digit1, setDigit1] = useState("");
    const [digit2, setDigit2] = useState("");
    const [digit3, setDigit3] = useState("");
    const [digit4, setDigit4] = useState("");
    const [digit5, setDigit5] = useState("");
    const [digit6, setDigit6] = useState("");

    const redirect = useNavigate();

    const handlePaste = (e) => {
        e.preventDefault();

        const pasteData = e.clipboardData.getData("text").replace(/\D/g, "");
        if (!pasteData || pasteData.length !== 6) return;

        setDigit1(pasteData[0]);
        setDigit2(pasteData[1]);
        setDigit3(pasteData[2]);
        setDigit4(pasteData[3]);
        setDigit5(pasteData[4]);
        setDigit6(pasteData[5]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const code = `${digit1}${digit2}${digit3}${digit4}${digit5}${digit6}`;
            await verifyOtpCode(otpEmail, code);
            redirect(routes.public.auth.reset.abs);
        } catch (error) {
            alert(error.message);
        }
    };

    const handleResend = async (e) => {
        e.preventDefault();

        try {
            await sendOtpCode(otpEmail);
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <>
            <article className="auth__article">
                <form
                    className="auth__form"
                    name="verification"
                    onSubmit={handleSubmit}
                >
                    <Logo isLink={true} />
                    <FormHeader {...schema.formHeader} />
                    <fieldset className="verification__container">
                        <DigitField
                            id={"digit-1"}
                            digit={digit1}
                            setDigit={setDigit1}
                            fieldID={"digit-1"}
                            prevFieldID={null}
                            nextFieldID={"digit-2"}
                            onPaste={handlePaste}
                        />
                        <DigitField
                            id={"digit-2"}
                            digit={digit2}
                            setDigit={setDigit2}
                            fieldID={"digit-2"}
                            prevFieldID={"digit-1"}
                            nextFieldID={"digit-3"}
                            onPaste={handlePaste}
                        />
                        <DigitField
                            id={"digit-3"}
                            digit={digit3}
                            setDigit={setDigit3}
                            fieldID={"digit-3"}
                            prevFieldID={"digit-2"}
                            nextFieldID={"digit-4"}
                            onPaste={handlePaste}
                        />
                        <DigitField
                            id={"digit-4"}
                            digit={digit4}
                            setDigit={setDigit4}
                            fieldID={"digit-4"}
                            prevFieldID={"digit-3"}
                            nextFieldID={"digit-5"}
                            onPaste={handlePaste}
                        />
                        <DigitField
                            id={"digit-5"}
                            digit={digit5}
                            setDigit={setDigit5}
                            fieldID={"digit-5"}
                            prevFieldID={"digit-4"}
                            nextFieldID={"digit-6"}
                            onPaste={handlePaste}
                        />
                        <DigitField
                            id={"digit-6"}
                            digit={digit6}
                            setDigit={setDigit6}
                            fieldID={"digit-6"}
                            prevFieldID={"digit-5"}
                            nextFieldID={null}
                            onPaste={handlePaste}
                        />
                    </fieldset>
                    <TextButton
                        {...schema.textButton}
                        onClick={handleSubmit}
                    ></TextButton>
                    <hr></hr>
                    <AuthPrompt {...schema.authPrompt} onClick={handleResend} />
                </form>
            </article>
        </>
    );
}

export default VerificationCodePage;
